import { combineReducers } from 'redux';

import byId from './byId/reducer';
import categorySelection from './categorySelection/reducer';

export default combineReducers({
  byId,
  categorySelection
});



/** WEBPACK FOOTER **
 ** ./src/members/state/categories/reducer.js
 **/